import { FunctionComponent, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IWorkroomExtended } from 'Frontend/scripts/models/workrooms.model'
import { approveWorkroom, deleteWorkroom } from 'Frontend/scripts/services/workrooms.service'
import { useManageWorkroomsContext } from './manageWorkroomContext'
import Dialog from 'Features/Dialog/Dialog'

interface IApplicationProps {
  workroom: IWorkroomExtended
  callback: () => void
}

const WorkroomApplicationItem: FunctionComponent<IApplicationProps> = ({ workroom, callback }) => {
  const { getAllWorkrooms } = useManageWorkroomsContext()
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const approveNewWorkroom = (workroomId: number) => {
    approveWorkroom(workroomId).then(() => {
      getAllWorkrooms()
      callback()
    })
  }

  const deleteNewWorkroom = (workroomId: number) => {
    deleteWorkroom(workroomId).then(() => {
      getAllWorkrooms()
      callback()
    })
  }

  const createMarkup = (body: string) => {
    return { __html: body }
  }

  return (
    <>
      <div className="border-bottom">
        <Button className={`member-application__member-row ${isOpen ? 'mb-3' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          {workroom.name} <i className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
        </Button>
        {isOpen && (
          <div className="member-application__detailed-info">
            <label>{t('description')}:</label>
            <div dangerouslySetInnerHTML={createMarkup(workroom?.description)}></div>

            <label>{t('justification')}:</label>
            <p>{workroom?.creationReasonText}</p>

            <label>{t('type-of-workroom')}:</label>
            <p>{workroom.workroomCategoryId == 0 ? 'Nationellt' : 'Regionalt'}</p>

            {workroom.ownerUser !== null && (
              <>
                <label>{t('dashboard.workrooms.created-by')}: &nbsp;</label>
                <a href={workroom.ownerUser.viewProfileUrl}>
                  {workroom.ownerUser.firstname} {workroom.ownerUser.lastname}
                </a>
              </>
            )}
            <div className="d-flex justify-content-center gap-3 my-4">
              <Button
                variant="secondary"
                className="gap-2 livstecknet-thread__edit-question px-2"
                onClick={() => approveNewWorkroom(workroom.id)}
              >
                <span className="fa fa-check"></span>
                {t('approve-workroom')}
              </Button>
              <Button
                variant="dark"
                className="gap-2 livstecknet-thread__edit-question px-2"
                onClick={() => setIsDialogOpen(true)}
              >
                <span className="fa fa-trash-o"></span>
                {t('delete-workroom')}
              </Button>
            </div>
          </div>
        )}
      </div>
      <Dialog
        callbackClose={() => setIsDialogOpen(false)}
        callbackSubmit={() => deleteNewWorkroom(workroom.id)}
        isOpen={isDialogOpen}
        buttonVariant="secondary"
        abortText={t('abort')}
        submitText={t('yes')}
        verificationText={`${t('workrooms.do-you-want-to-delete-workroom')} "${workroom.name}"`}
      ></Dialog>
    </>
  )
}

export default WorkroomApplicationItem
